import "../plugins/slickPlugin"

export default function initM111() {
    $('.img-slider').each(function () {
        $(this).slick({
            dots: false,
            slidesToShow: 1,
            // waitForAnimate: false,
            infinite: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: $(this).data('speed'),
        });
    })
}